'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBus = exports.InternalEventDispatcher = exports.OutgoingEventDispatcher = exports.IncomingEventDispatcher = exports.emitAsync = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _AppEventEmitter = require('./AppEventEmitter');

var _AppEventEmitter2 = _interopRequireDefault(_AppEventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @internal
 *
 * @param {AppEventEmitter} eventDispatcher
 * @param {String} eventName
 * @param {Array} args
 *
 * @return {Promise}
 */
var dispatch = function dispatch(eventDispatcher, eventName) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var emitBinding = eventDispatcher.emit.bind(eventDispatcher);

  var executor = function executor(resolve, reject) {
    var emitArgs = [eventName, resolve, reject].concat(args);
    return emitBinding.apply(null, emitArgs);
  };

  return new _promise2.default(executor);
};

/**
 * A substitute for `AppEventEmitter.emit`
 *
 * @function
 * @param {AppEventEmitter} eventDispatcher
 * @return {Promise}
 */
/**
 * This module exports {@link AppEventEmitter} objects which are used as event buses to handle application message
 * @module Core/emit
 */

var emitAsync = exports.emitAsync = function emitAsync(eventDispatcher) {
  var dispatchBinding = dispatch.bind(null, eventDispatcher);
  return _promise2.default.resolve(dispatchBinding);
};

/**
 * @type {AppEventEmitter}
 */
var IncomingEventDispatcher = exports.IncomingEventDispatcher = new _AppEventEmitter2.default();

/**
 * @type {AppEventEmitter}
 */
var OutgoingEventDispatcher = exports.OutgoingEventDispatcher = new _AppEventEmitter2.default();

/**
 * @type {AppEventEmitter}
 */
var InternalEventDispatcher = exports.InternalEventDispatcher = new _AppEventEmitter2.default();

/**
 * @type {AppEventEmitter}
 */
var MessageBus = exports.MessageBus = new _AppEventEmitter2.default();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/emit.js
// module id = 157
// module chunks = 0